<template>
    <div>
        <div style="height: 50px"></div>
        <v-footer
                height="auto"
                style="position: absolute; bottom: 0px; width: 100%; height: 50px"
        >
            <v-layout
                    justify-center
                    row
                    wrap
            >
                <v-flex
                        secondary
                        py-3
                        text-xs-center
                        black--text
                        xs12
                >
                    <strong>Copyright © 2016 Lemon Concentrate.</strong> All rights reserved.
                    Developed by <a href="https://www.sozpic.com/" target="_blank">Sozpic</a>
                </v-flex>
            </v-layout>
        </v-footer>
    </div>

</template>

<script>
    export default {
        name: "FooterComponent"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/FooterComponent.vue